import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import RobotaRouter from "./RobotaRouter";
import "bootstrap/dist/css/bootstrap.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <RobotaRouter />
  </BrowserRouter>
);
